import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import Detail from "../../components/common/detail/Detail";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import {fetchTransactionTypeById} from "../../store/transaction-type-slice";
import {getDetailData} from "../../models/transactionTypeModel";

const TransactionTypeDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.transactionType);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.transactionType);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchTransactionTypeById({...userRole, id: params.transactionTypeId}));
    }, [dispatch, params.transactionTypeId, userRole]);

    const item = items.find(item => item.id === params.transactionTypeId);
    const detailData = getDetailData({item});
    return (
        <>
            <SubHeader title="Transaction Type Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>}
            </div>
        </>
    )
}

export default TransactionTypeDetail;